import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { RateSummary } from '@app/_components/rate/rate-summary';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class RateSummaryService
{
	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'rate-summaries';

	searchRateSummaries(rateSummary: RateSummary): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(rateSummary));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/rate-managers/rate-summary`, rateSummary);
	}

	updateRateSummary(rateSummary: RateSummary): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(rateSummary));
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/rate-managers/rate-summary`, rateSummary);
	}

}
